import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { DrawerBodyWrapper, DrawerFooterWrapper } from '@base'
import { CRAN_SECTION_TYPES } from '@constants'
import { getCranReportById } from '@data/conn/get/cranReport'
import { addCommentInCranReport } from '@data/conn/post/cranReport'
import { showLoader } from '@data/state/action'
import { useForceUpdate } from '@hooks'
import { InputWrapper } from '../styles'
import ProbeTextArea from '../Components/ProbeTextArea'

const dataToForm = (prevState, data) => {
	if (data === null) {
		return prevState
	}
	let _obj = data?.slice(-1)?.[0]
	return {
		...prevState,
		value: _obj?.comment,
		show_in_cran: _obj?.show_in_cran,
		comment_type: _obj?.comment_type,
		dirty: true,
	}
}


const deriveFormState = (data) => {
	const _state = {
		overall_shareholdings: {
			label: 'Overall Comment',
			placeholder: 'Enter overall comment here',
			value: '',
			show_in_cran: false,
			comment_type: null,
			disabled: false,
			dirty: false,
		},
	}

	if (data) {
	_state.overall_shareholdings =dataToForm(_state.overall_shareholdings,data?.overall_shareholdings)

	}
	return _state
}

const ShareholdingForm = ({ probeId }) => {
	const dispatch = useDispatch()
	const [formState, setFormState] = useState(deriveFormState())
	const loggedInUser = useSelector((state) => state.getIn(['user', 'user']))
	const [forceUpdate, update] = useForceUpdate()

	useEffect(() => {
		dispatch(showLoader(true))
		getCranReportById(probeId, [CRAN_SECTION_TYPES.SHAREHOLDING])
			.then((response) => {
				setFormState(deriveFormState(response))
			})
			.catch((error) => {
				console.log(error)
			})
			.finally(() => {
				dispatch(showLoader(false))
			})
	}, [forceUpdate])

	const updateState = (key) => (value) => {
		setFormState((_s) => ({
			..._s,
			[key]: {
				..._s[key],
				value: value,
			},
		}))
	}

	const updateCheckHandler = (key) => (val) => {
		setFormState((_s) => ({
			..._s,
			[key]: {
				..._s[key],
				show_in_cran: val,
			},
		}))
	}

	const commentTypeHandler = (key) => (value) => {
		setFormState((_s) => ({
			..._s,
			[key]: {
				..._s[key],
				comment_type: value,
			},
		}))
	}

	const addHandler = (key) => () => {
		let obj = formState[key]
		let comment = {
			comment: obj.value,
			comment_type: obj.comment_type,
			created_by: loggedInUser?.user_id,
			show_in_cran: obj?.show_in_cran,
			// created_at: new Date().getTime(),
		}
		dispatch(showLoader(true))
		addCommentInCranReport({
			userId: loggedInUser?.user_id,
			commentValue: comment,
			commentKey: key,
			probe42Id: probeId,
		})
			.then((response) => {})
			.catch((error) => {})
			.finally(() => {
				update()
				dispatch(showLoader(false))
			})
	}
	return (
		<>
			<DrawerBodyWrapper>
				<InputWrapper>
					<ProbeTextArea
						label={formState?.overall_shareholdings?.label}
						placeholder={formState?.overall_shareholdings?.placeholder}
						toggleState={formState?.overall_shareholdings?.comment_type}
						textValue={formState?.overall_shareholdings?.value}
						onTextChange={updateState('overall_shareholdings')}
						onCheckHandler={updateCheckHandler('overall_shareholdings')}
						checkValue={formState?.overall_shareholdings?.show_in_cran}
						onToggleChange={commentTypeHandler('overall_shareholdings')}
						onButtonClick={addHandler('overall_shareholdings')}
						disabled={formState?.overall_shareholdings?.disabled}
					/>
				</InputWrapper>
			</DrawerBodyWrapper>
			<DrawerFooterWrapper></DrawerFooterWrapper>
		</>
	)
}

export default ShareholdingForm
